<template>
  <div id="ca-sidesheet-creacion">

    <ca-sidesheet
      :show.sync="show_sidesheet_creacion"
      :titulo="tituloSidesheetCreacion"
      width="600px"
      :close_outside= false
      :loading="loading"
      botonera_inferior
      content_class="content-sidesheet-creacion"
    >

      <!-- Selección de administración -->
      <vista-seleccion-administracion
        v-if="show_vista_seleccion_administracion"
        ref="vista_seleccion_administracion"
        :acuerdo_comercial.sync="acuerdo_comercial"
        :plantillas="plantillas"
        :administraciones="administraciones"
      >
      </vista-seleccion-administracion>

      <!-- Vista seleccion de administracion y sus consorcios -->
      <vista-seleccion-consorcios
        v-if="show_vista_seleccion_consorcios"
        ref="vista_seleccion_consorcios"
        :acuerdo_comercial.sync="acuerdo_comercial"
        :administraciones="administraciones"
        :loading.sync="loading"
      >
      </vista-seleccion-consorcios>

      <!-- Seleccion plantilla - personalizada -->
      <vista-seleccion-plantilla-personalizada
        v-if="show_vista_seleccion_plantilla_personalizada"
        ref="vista_seleccion_plantilla_personalizada"
        :acuerdo_comercial.sync="acuerdo_comercial"
        :plantillas="plantillas"
      >
      </vista-seleccion-plantilla-personalizada>

      <!-- Contenido de sidesheet -->
      <div class="contenedor-sidesheet" v-if="acuerdo_comercial">

        <!-- Campos principales a completar de un acuerdo comercial -->
        <vista-formulario-campos-principales-acuerdo
          v-if="show_vista_formulario_campos_principales_acuerdo"
          ref="vista_formulario_campos_principales_acuerdo"
          :acuerdo_comercial.sync="acuerdo_comercial"
        >
        </vista-formulario-campos-principales-acuerdo>

        <!-- Vista previa del acuerdo -->
        <vista-previa-acuerdo
          v-if="show_vista_previa"
          ref="vista_previa"
          :acuerdo_comercial.sync="acuerdo_comercial"
          @acuerdo-comercial:seleccionado="consorcio_seleccionado = $event"
          modo_creacion
        >

          <!-- Utilizamos el slot para inyectar la tabla de totales a facturar (opcional) -->
          <div slot="post-observaciones-facturacion" v-if="acuerdo_comercial.tipo_propuesta === TIPO_ACUERDO_VINCULADO_A_CONSORCIO && show_vista_previa && consorcio_seleccionado" class="pt-8">
            <tabla-total-a-facturar-acuerdo-comercial
              v-if="consorcio_seleccionado"
              :acuerdo_comercial="acuerdo_comercial"
              :consorcio="consorcio_seleccionado"
            />
          </div>

        </vista-previa-acuerdo>

      </div>

      <!-- Footer con los botones de acciones -->
      <div slot="footer-izquierda">
        <v-btn class="boton-cancelar" @click="finalizarOperacion()">Cancelar</v-btn>
      </div>
      <div slot="footer-derecha">
        <v-btn v-if="mostrarBotonAtras" outlined @click="pasoAnterior()" class="boton-atras">Atrás</v-btn>
        <v-btn class="ml-4 mr-2" @click="siguientePaso()">{{ this.labelBotonContinuar }}</v-btn>
      </div>
    </ca-sidesheet>

  </div>
</template>

<script>
import VistaSeleccionPlantillaPersonalizada from './vistas-sidesheet/VistaSeleccionPlantillaPersonalizada.vue';
import VistaPreviaAcuerdo from './vistas-sidesheet/VistaPreviaAcuerdo.vue';
import VistaSeleccionAdministracion from './vistas-sidesheet/VistaSeleccionAdministracion.vue';
import VistaFormularioCamposPrincipalesAcuerdo from './vistas-sidesheet/VistaFormularioCamposPrincipalesAcuerdo.vue';
import VistaSeleccionConsorcios from './vistas-sidesheet/VistaSeleccionConsorcios.vue';
import { APIAcuerdoComercial } from '../api/acuerdo-comercial.api';
import { AcuerdoComercial } from '../../../models/AcuerdoComercial';
import * as acuerdo_comercial_constantes from '../acuerdo-comercial.consts';
import { APIGeneralSales } from '../api/general.api';
import './vistas-sidesheet/vistas-sidesheet-style.scss'; // Estilos en común para las vistas
import { CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN, CACHE_ADMIN_MUTATION_OBTENER_UNA_ADMIN } from '@/store/administraciones/administraciones.types';
import { LAYOUT_MUTATION_SNACKBAR_EXITO } from '@/store/layout/layout.types';
import TablaTotalAFacturarAcuerdoComercial from './TablaTotalAFacturarAcuerdoComercial.vue';
import { EventBus } from '@/main';
import { ENDPOINT_GETTER } from '@/store/endpoints/endpoints.types';

export default {
  name:'SidesheetCreacionAcuerdo',
  components:{
    VistaSeleccionPlantillaPersonalizada,
    VistaPreviaAcuerdo,
    VistaSeleccionAdministracion,
    VistaFormularioCamposPrincipalesAcuerdo,
    VistaSeleccionConsorcios,
    TablaTotalAFacturarAcuerdoComercial
  },
  /**
   * Idea general para manejar el flujo entre las distintas pantallas que tiene el sidesheet
   * - La mayor logica lo tiene la "creación del acuerdo comercial"
   *
   *    La idea es que la creación del acuerdo puede ser para:
   *      - Libre
   *      - Vinculada a una administración (por_defecto)
   *      - Vinculada a consorcios (uno o masivamente)
   *
   *    Esto conlleva a distintos pasos (camino) a seguir para la creación, por lo tanto, estos pasos estan almanceandos en camino_actual.camino, y se lleva a la par el paso_actual para tener de referencia en que parte del camino se encuentra
    *
   * Entonces el watch de "camino_actual" es la clave para movernos, ya que se activa cada vez que avanza (incrementa) un paso, es decir, se avanza camino_actual.paso_actual, disparando la activación de la vista que corresponde y apagando las restantes, haciendo que se reinicien.
   *
   * Aspectos claves del flujo
   * - El acuerdo comercial (objeto) es pasado entre las distintas vistas las cuales se van montando cuando son necesarias.
   * - Cuando se monta se hace un clon del acuerdo pasada por props
   * - Como los inputs estan ligados a las propiedades del AC clonado, se auton rellenaran los campos si es que estos estan cargados
   * - Ante modificaciones en los inputs de los formularios de cada vista, modifican directamente un atributo del acuerdo clonada
   *    - A excepción del la vista creación que usa algunas variables internas y no atributos del AC directamente
   *
   * - Como el boton siguiente pertenece a este componente (y no en concreto a cada vista) tiene una logica particular:
   *   - Cuando se le da a siguiente, dispara un evento en el hijo (que va a ser una vista en concreto) para validar el formulario que contenga
   *   - Ahi se tiene el chequeo de cada vista, si lo pasa, se emite evento para actualizar el AC (objeto) y se continua el flujo del camino
   *   - Si no se valida, no se emite nada y se notifica en el formulario de cada vista que es lo que esta mal
   */
  props:{
    show_sidesheet_creacion: { type: Boolean, default: false },
    camino: { type: Object, default: () => {} },
    tipo_acuerdo: { type: String, default: acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION }, // Antes era por defecto LIBRE pero se cambió por defecto a ADMINISTRACION porque ocultamos temporalmente los acuerdos libres

    // Props para crear acuerdos para consorcios pendientes
    modo_creacion_para_consorcios_pendientes: { type: Boolean, default: false }, // Flag para activar el modo creacion para consorcios pendientes
    consorcios_pendientes: { type: Array, default: () => [] }, // Lista de consorcios pendientes que selecciono el usuario
    tipo_creacion_para_consorcios_pendientes:{ type: Number, default: acuerdo_comercial_constantes.TipoCreacionPendientes.CREAR_DESDE_CERO }, // Forma de creación
    consorcios_pendientes_distinta_administracion: { type: Boolean, default: true } // Flag para saber si los consorcios pendientes son de una administración en particular
  },
  data: () => ({

    // Camino son la serie de pasos que se deben seguir para crear un acuerdo comercial
    // y el paso_actual es necesario para saber en que paso se encuentra el usuario en la creación
    camino_actual: {'camino': [], 'paso_actual': 0},

    acuerdo_comercial: null, // acuerdo comercial donde se rellenarar los campos para crear el acuerdo
    acuerdo_comercial_original: null, // Necesaria para comparar si se modifico algo en el acuerdo comercial (por plantilla)

    plantillas: [], // Arreglo de plantillas
    administraciones: [], // Arreglo de administraciones

    loading: false, // Flag para controlar el loading dentro del sidesheet

    consorcio_seleccionado: null, // Consorcio seleccionado en la vista previa

    // Constante usadas en el template
    TIPO_ACUERDO_LIBRE: acuerdo_comercial_constantes.TipoAcuerdo.LIBRE, // [acuerdo_libre - no esta en uso actualmente]
    TIPO_ACUERDO_POR_DEFECTO: acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION,
    TIPO_ACUERDO_VINCULADO_A_CONSORCIO: acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO,
    CREAR_DESDE_CERO: acuerdo_comercial_constantes.TipoCreacionPendientes.CREAR_DESDE_CERO,
    USAR_ACUERDO_POR_DEFECTO_ADMIN: acuerdo_comercial_constantes.TipoCreacionPendientes.USAR_ACUERDO_POR_DEFECTO_ADMIN,

    // Endpoints utilizados en la creación de acuerdos (se van a recuperar del store de endpoints)
    get_endpoint_plantillas: null,
    get_endpoint_administraciones: null,
  }),
  computed:{

    /**
     * Titulo del sidesheet dinamico dependiendo del tipo de acuerdo que se va a crear y el modo de creación
     */
    tituloSidesheetCreacion(){

      // En caso de estar en la creación para consorcios pendientes
      if(this.modo_creacion_para_consorcios_pendientes){
        return 'ASIGNAR ACUERDO';
      }else {
        switch (this.tipo_acuerdo) {
        case acuerdo_comercial_constantes.TipoAcuerdo.LIBRE: // [acuerdo_libre - no esta en uso actualmente]
          return 'NUEVO ACUERDO LIBRE';
        case acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION:
          return 'NUEVO ACUERDO ADMINISTRACIÓN';
        default:
          return 'NUEVO ACUERDO PARA CONSORCIOS';
        }
      }
    },

    /**
     * Calculo el label del boton "Continuar" dependiendo de que viste este
     */
    labelBotonContinuar(){
      return this.show_vista_previa ? 'Confirmar' : 'Siguiente';
    },

    /**
     * Calcula en que vistas del sidehseet, dependiendo el caso, se muestra el boton atrás
     */
    mostrarBotonAtras(){

      // Si esta en el primer o ultimo paso del camino se oculta
      let ultimo_paso = this.camino_actual.camino.length;
      if (this.camino_actual.paso_actual === 0 ||this.camino_actual.paso_actual === ultimo_paso){
        return false;
      }

      return true;
    },

    // Computeds para activar la vista que se deben mostrar
    show_vista_seleccion_administracion(){
      return this.camino_actual.camino[this.camino_actual.paso_actual] === acuerdo_comercial_constantes.VISTA_SELECCION_ADMINISTRACION && this.show_sidesheet_creacion;
    },

    show_vista_seleccion_consorcios(){
      return this.camino_actual.camino[this.camino_actual.paso_actual] === acuerdo_comercial_constantes.VISTA_SELECCION_CONSORCIOS && this.show_sidesheet_creacion;
    },

    show_vista_previa(){
      return this.camino_actual.camino[this.camino_actual.paso_actual] === acuerdo_comercial_constantes.VISTA_PREVIA && this.show_sidesheet_creacion;
    },

    show_vista_formulario_campos_principales_acuerdo(){
      return this.camino_actual.camino[this.camino_actual.paso_actual] === acuerdo_comercial_constantes.VISTA_CREACION_ACUERDO && this.show_sidesheet_creacion;
    },

    show_vista_seleccion_plantilla_personalizada(){
      return this.camino_actual.camino[this.camino_actual.paso_actual] === acuerdo_comercial_constantes.VISTA_SELECCION_PLANTILLA_PERSONALIZADA && this.show_sidesheet_creacion;
    },
  },
  watch: {

    /**
     * Watch necesario para:
     *  - Seteo el camino a seguir
     *  - Clono el tipo de acuerdo
     *  - Recupero una unica vez las adminsitraciones y las plantillas. 
     *    - Primero recuperamos todas las administraciones y luego buscamos las plantillas (en ambas el llamado tiene un await para frenar el avance hasta que se haya recuperado la información actualizada primero)
     *
     * @param {Boolean} new_value
     */
    async show_sidesheet_creacion(new_value){
      if (new_value){
        this.camino_actual = _.cloneDeep(this.camino);

        this.inicializarAcuerdo(); // Inicializo el AC

        this.consorcio_seleccionado = null; // Reseteo el consorcio seleccionado

        if (!this.modo_creacion_para_consorcios_pendientes){ // No es necesario en el caso que sea este modo de creación
          // Busco las administraciones en el caso que NO sea un acuerdo libre y no esten cacheadas [acuerdo_libre - no esta en uso actualmente]
          if (this.tipo_acuerdo !== acuerdo_comercial_constantes.TipoAcuerdo.LIBRE){
            if (!this.administraciones.length && this.get_endpoint_administraciones){
              await this.getAdministraciones();
            }
          }
        }

        // Busco las plantillas en el caso que no esten cacheadas
        if(!this.plantillas.length && this.get_endpoint_plantillas){
          await this.getPlantillas();
        }
      }
    },

    /**
     * Watch para activar que vista debe ser mostrada a medida que cambia el camino_actual
     * Se busca en que paso esta del camino actual y en base a eso se activa la vista correspondiente
     */
    camino_actual(){
      if (this.show_sidesheet_creacion){
        let vista_a_activar = this.camino_actual.camino[this.camino_actual.paso_actual];

        switch (vista_a_activar) {

        // Ambas son las pantallas iniciales de cualquier acuerdo
        case acuerdo_comercial_constantes.VISTA_SELECCION_ADMINISTRACION:
        case acuerdo_comercial_constantes.VISTA_SELECCION_PLANTILLA_PERSONALIZADA:
          break;
        case acuerdo_comercial_constantes.EJECUTAR_CREACION_AC:
          this.crearAcuerdo();
          break;
        case acuerdo_comercial_constantes.FINALIZAR_OPERACION:
          this.finalizarOperacion();
          break;
        default:
          break;
        }
      }
    },
  },
  mounted() {

    // Seteamos los endpoints necesarios para la creación de acuerdos al montar el componente y los obtenemos del store de endpoints (los guardamos en variables para evitar hacer la consulta al store cada vez que se usen)
    this.get_endpoint_plantillas = this.$store.getters[ENDPOINT_GETTER]('plantillas');
    this.get_endpoint_administraciones = this.$store.getters[ENDPOINT_GETTER]('administraciones');
  },
  methods: {

    /**
     * Llamado al GET de todas las plantillas
     */
    async getPlantillas(){
      if(!this.get_endpoint_plantillas) {
        return;
      }

      this.loading = true;
      await APIAcuerdoComercial.getPlantillas(this.get_endpoint_plantillas)
        .then((resp) => {
          this.plantillas = resp;
        })
        .catch((err) => {
          console.log(err);
          this.$emit('finalizada-error:creacion', err.detail);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * Llamado al GET de todas las administraciones
     */
    async getAdministraciones() {
      if(!this.get_endpoint_administraciones){
        return;
      }

      this.loading = true;
      await APIGeneralSales.getAdministraciones(this.get_endpoint_administraciones)
        .then((resp) => {
          this.administraciones = resp;
          // Creo la booleana para saber si tiene acuerdo comercial, es necesario usar la boolean y no el link para la verificacion
          // por el caso posterior de crear acuerdos por defecto y no tener el link
          this.administraciones.forEach((admin) => {
            admin.tiene_acuerdo_comercial = admin.hasApiLink('propuesta_comercial');
            // Agrego los atributos necesarios para el autocomplete en las vistas donde se tiene que seleccionar la administración
            // Con esto aprovecho el loading y el recorrido
            admin.text= '[' + admin.id + '] ' + admin.nombre;
          });
        })
        .catch((err) => {
          console.log(err);
          this.$emit('finalizada-error:creacion', err.detail);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * Metodo invocado desde el padre, cuando se elimina el acuerdo por defecto de una administración
     * Lo que se hace es buscar la administración y apagar el flag tiene acuerdo comercial
     * Asi evitando hacer un GET de las administraciones nuevamente
     */
    actualizarAdministracion(admin_modificada){
      let index = this.administraciones.findIndex((admin) => admin.id === admin_modificada.id);
      index !== -1 ? this.administraciones[index].tiene_acuerdo_comercial = false : null;
    },

    /**
     * - Incremento el paso actual para recalcular, gracias al watch del camino, que vista debe mostrase
     * - Además valido en la vista que esta actualmente, invocando un UPDATE (gracias .sync) para actualizar el AC
     * - Relleno el AC con la plantilla, en caso de estar en pantalla inicial
     */
    siguientePaso(){
      let vista_actual = this.camino_actual.camino[this.camino_actual.paso_actual];
      switch (vista_actual) {
      case acuerdo_comercial_constantes.VISTA_SELECCION_CONSORCIOS:
        if(!this.$refs.vista_seleccion_consorcios.validarFormulario()){
          return;
        }
        break;
      case acuerdo_comercial_constantes.VISTA_CREACION_ACUERDO:
        if(!this.$refs.vista_formulario_campos_principales_acuerdo.validarFormulario()){
          return;
        }
        break;
      case acuerdo_comercial_constantes.VISTA_SELECCION_PLANTILLA_PERSONALIZADA:
        if(!this.$refs.vista_seleccion_plantilla_personalizada.validarFormulario()){
          return;
        }
        break;
      case acuerdo_comercial_constantes.VISTA_SELECCION_ADMINISTRACION:
        if(!this.$refs.vista_seleccion_administracion.validarFormulario()){
          return;
        }
        break;
      case acuerdo_comercial_constantes.VISTA_PREVIA:{
        this.$refs.vista_previa.emitirAcuerdoModificado();
        break;
      }
      default:
        break;
      }
      // En caso que este en cualquiera de las vistas iniciales y selecciono plantilla, se rellena el AC.
      // Este seria como un "reinicio" en caso que vuelva a las vistas iniciales
      if (vista_actual === acuerdo_comercial_constantes.VISTA_SELECCION_PLANTILLA_PERSONALIZADA || vista_actual === acuerdo_comercial_constantes.VISTA_SELECCION_ADMINISTRACION || vista_actual === acuerdo_comercial_constantes.VISTA_SELECCION_CONSORCIOS){
        if (this.acuerdo_comercial.plantilla){
          this.acuerdo_comercial.rellenarConAcuerdo(this.acuerdo_comercial.plantilla);
        }
        else{ // Caso borde: Elije plantilla lo cual pre-carga, vuelve para atrás y decide personalizada (el AC quedo cargado con la plantilla) con esto reinicio, pero conservo lo que pudo haber cambiado en cada vista inicial
          let consorcio_propuesta_libre = this.acuerdo_comercial.consorcio_propuesta_libre; // Guardo la consorcio_propuesta_libre (vista seleccion plantilla personalizada) [acuerdo_libre - no esta en uso actualmente]

          let administracion = this.acuerdo_comercial.administracion; // Guardo la administración (vista seleccion administración);

          // Guardo los atributos modificados (momentaneamente) en vista seleccion consorcios
          let administracion_seleccionada = this.acuerdo_comercial.administracion_seleccionada ?? null;
          let consorcios_seleccionados = this.acuerdo_comercial.consorcios_seleccionados ?? [];
          let consorcios = this.acuerdo_comercial.consorcios ?? [];
          let tipo_producto = this.acuerdo_comercial.tipo_producto;
          let consorcios_filtrados_por_ca_filtro = this.acuerdo_comercial.consorcios_filtrados_por_ca_filtro;
          let ocultar_deshabilitadas = this.acuerdo_comercial.ocultar_deshabilitadas;
          let filtro_ca_tabla = this.acuerdo_comercial.filtro_ca_tabla;
          let filtro_edificio_barrio = this.acuerdo_comercial.filtro_edificio_barrio ?? true;

          this.inicializarAcuerdo();

          this.acuerdo_comercial.consorcio_propuesta_libre = consorcio_propuesta_libre; // [acuerdo_libre - no esta en uso actualmente]

          this.acuerdo_comercial.administracion = administracion;

          this.acuerdo_comercial.administracion_seleccionada = administracion_seleccionada;
          this.acuerdo_comercial.consorcios_seleccionados = consorcios_seleccionados;
          this.acuerdo_comercial.consorcios = consorcios;
          this.acuerdo_comercial.tipo_producto = tipo_producto;
          this.acuerdo_comercial.consorcios_filtrados_por_ca_filtro = consorcios_filtrados_por_ca_filtro;
          this.acuerdo_comercial.filtro_ca_tabla = filtro_ca_tabla;
          this.acuerdo_comercial.filtro_edificio_barrio = filtro_edificio_barrio;
          this.acuerdo_comercial.ocultar_deshabilitadas = ocultar_deshabilitadas;
        }

        this.acuerdo_comercial_original = _.cloneDeep(this.acuerdo_comercial); // Clono para tener la original para luego compararla
      }

      // Si pasa todas las validaciones de la vista que este
      this.camino_actual = {
        camino: this.camino_actual.camino,
        paso_actual: ++this.camino_actual.paso_actual,
      };

      this.posicionarArribaScroll(); // Posiciono el scroll arriba del todo del sidesheet
    },

    /**
     * Posiciona el scroll arriba del todo del sidesheet
     */
    posicionarArribaScroll() {
      const sidesheet_content = document.querySelector('#ca-sidesheet-creacion .ca-sidesheet-content');
      if (sidesheet_content) {
        sidesheet_content.scrollTop = 0;
      }
    },

    /**
     * Reduzco el paso actual en uno para recalcular, gracias al watch del camino, que vista debe mostrase
     */
    pasoAnterior(){
      this.camino_actual = {
        camino: this.camino_actual.camino,
        paso_actual: --this.camino_actual.paso_actual,
      };

      this.posicionarArribaScroll(); // Posiciono el scroll arriba del todo del sidesheet
    },

    /**
     * Metodo que finaliza la operación ocultado el sidesheet y el padre reiniciará
     */
    finalizarOperacion(){
      this.$emit('update:show_sidesheet_creacion',false);
    },

    /**
     * Metodo que ejecuta la creación de un acuerdo sea del lado que venga (libre, por defecto, vinculada a un consorcio o masiva)
     */
    crearAcuerdo(){
      const url = this.$store.getters[ENDPOINT_GETTER]('crear_propuesta');
      if(!url) {
        return;
      }

      this.loading = true;

      // Si es por plantilla pero modifico algun campo, entonces pasa a ser personalizada.
      // En caso que se modifique un campo que NO es principal, seguira siendo plantilla (si asi inicio la creación)
      // Es por esto que las observaciones y el periodo son necesarios guardarlos temporalmente, luego comparar, y volver a setearlos
      let observaciones = this.acuerdo_comercial.observaciones;
      let periodo_inicio_facturacion = this.acuerdo_comercial.periodo_inicio_facturacion;
      this.acuerdo_comercial.observaciones = null;
      this.acuerdo_comercial.periodo_inicio_facturacion = null;

      if (this.acuerdo_comercial.plantilla){

        if (_.isEqual(this.acuerdo_comercial, this.acuerdo_comercial_original)){ // Seteo el nombre de la plantilla, porque es lo que se guarda
          this.acuerdo_comercial.plantilla = this.acuerdo_comercial.plantilla.nombre_plantilla;
        }
        else{
          this.acuerdo_comercial.plantilla = null; // Hubo cambios, borro la plantilla
        }
      }

      // Vuelvo a setearlos
      this.acuerdo_comercial.observaciones = observaciones;
      this.acuerdo_comercial.periodo_inicio_facturacion = periodo_inicio_facturacion;

      // Elimino el atributo observaciones en caso que sea libre o para la administración (solo es posible en el momento de asignarla a un consorcio)
      if (this.acuerdo_comercial.tipo_propuesta !== acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO){
        delete this.acuerdo_comercial.observaciones;
      }

      // Sino es para la administración, elimino los descuentos de cochera en caso que tenga seteado y sea barrio
      // Esto sucede porque la plantilla puede tener descuentos para cocheras, pero cambia el tipo de consorcio 
      // Luego de seccionar la plantilla, entonces no se muestra (porque es barrio) pero los tiene seteados.
      if (this.acuerdo_comercial.tipo_propuesta !== acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION){
        if(this.acuerdo_comercial.tipo_producto === acuerdo_comercial_constantes.TipoConsorcio.BARRIO){
          if (this.acuerdo_comercial.descuentos_ufs && this.acuerdo_comercial.descuentos_ufs.tipos?.cochera){
            delete this.acuerdo_comercial.descuentos_ufs.tipos.cochera;
          }
        }
      }

      // Seteo las relaciones
      this.prepararRelacionesAcuerdo();

      APIAcuerdoComercial.crearAcuerdoComercial(url, this.acuerdo_comercial)
        .then((resp) => {

          let msg = '';

          // [acuerdo_libre - no esta en uso actualmente]
          if (this.tipo_acuerdo === acuerdo_comercial_constantes.TipoAcuerdo.LIBRE){
            // Emito el evento para que el padre actualice la cache y el contador de acuerdos libres, evitando asi llamado a la api nuevamente

            // Se accede a la primera de un arreglo, porque el endpoint esta preparado para devolver un arreglo de ACs (ya que se permite crear muchos acuerdos en un solo llamado)
            // Entonces en caso de ser una libre, siempre tiene un elemento, por eso accedo al primero.
            this.$emit('acuerdo-libre:creacion', resp[0]);

            // Muesto mensaje de exito
            msg = 'El acuerdo libre para ' + this.acuerdo_comercial.consorcio_propuesta_libre + ' se creó correctamente.';
            this.$store.commit(LAYOUT_MUTATION_SNACKBAR_EXITO, msg);
          }
          else{ // Por defecto o vinculada masivamente

            if (this.modo_creacion_para_consorcios_pendientes){
              msg = (this.consorcios_pendientes.length > 1) ? 'Se asociaron correctamente ' + this.consorcios_pendientes.length + ' acuerdos.' : 'Se asocio correctamente el acuerdo.';
              msg += '<br>Podés encontrar los acuerdos creados en la sección <strong>Buscador</strong>';

              // Elimino la administraciónes de los consorcios de la cache, porque puede haber seteado por defecto
              if (this.acuerdo_comercial.establecer_propuesta_por_defecto){
                this.$store.commit(CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN, this.acuerdo_comercial.administracion);
              }
            }
            else{

              // Mensaje para el snack
              if (this.tipo_acuerdo === acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO){
                msg = (this.acuerdo_comercial.consorcios_seleccionados.length > 1) ? 'Los acuerdos se crearon correctamente.' : 'El acuerdo se creó correctamente.';
                msg += '<br>Podés encontrar los acuerdos creados en la sección <strong>Buscador</strong>';

                // Le asigno el acuerdo que se creo a cada consorcio de esa administración
                // De esta manera se actualiza la lista de consorcios, de esa administración, con el acuerdo creado
                let admin_en_cache = this.$store.getters[CACHE_ADMIN_MUTATION_OBTENER_UNA_ADMIN](this.acuerdo_comercial.administracion);
                if (admin_en_cache){

                  // Por cada consorcio que se le creo el acuerdo, lo busco en la administración y le asigno la relación con el acuerdo para así queda marcado que tiene AC
                  this.acuerdo_comercial.consorcios_seleccionados.forEach((consorcio_ahora_con_acuerdo) => {

                    // Busco el consorcio en la administración cacheada
                    let consorcio_admin_cacheada = admin_en_cache.consorcios.find((consorcio_cacheado) => consorcio_cacheado.id === consorcio_ahora_con_acuerdo.id);

                    // Si el consorcio que ahora tiene acuerdo, esta en la cache de los consorcios de la administración, lo busco en la respuesta de la API para setearle la relación
                    if(consorcio_admin_cacheada) {

                      // Buscamos el indice del acuerdo comercial dentro del arreglo de los acuerdos recien creados (respuesta de la API) cuyo consorcio coincide con el consorcio actual cacheado, para poder asignarle el estado que le corresponde al AC vinculado al consorcio
                      let indice_acuerdo_con_consorcio_cacheado = resp.findIndex((acuerdo_comercial_creado) => acuerdo_comercial_creado.consorcio.id === consorcio_ahora_con_acuerdo.id);

                      // Al consorcio con la administración cacheada, le seteamos la relación del acuerdo comercial con su estado correspondiente, para que tambien quede guardado en la cache (y evitamos que se tenga que forzar el llamado nuevamente al endpoint)
                      if(indice_acuerdo_con_consorcio_cacheado !== -1) {
                        consorcio_admin_cacheada.propuesta_comercial = {
                          estado: resp[indice_acuerdo_con_consorcio_cacheado].estado
                        };
                      }
                    }
                  });

                  // Si tildo el checkbox marco la administración
                  if (this.acuerdo_comercial.establecer_propuesta_por_defecto){
                    admin_en_cache.tiene_acuerdo_comercial = true;
                  }
                }
              }

              if (this.tipo_acuerdo === acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION){

                // Marco la administración para actualizar las administración sin llamar al endpoint nuevamente
                // Busqueda eficiente, porque con .findIndex / .find no funciona por ser otro objeto
                let encontre = false;
                for (let i = 0; i < this.administraciones.length && !encontre; i++) {
                  const admin = this.administraciones[i];
                  if (admin.id === this.acuerdo_comercial.administracion.id){
                    admin.tiene_acuerdo_comercial = true;
                    encontre = true;
                  }
                }

                // La elimino de la cache, para forzar a buscar nuevamente la administración
                this.$store.commit(CACHE_ADMIN_MUTATION_ELIMINAR_ADMIN, this.acuerdo_comercial.administracion);

                // Si fue por defecto es en singular el msg
                msg = 'El acuerdo se creó correctamente';
              }
            }

            // Emito evento para que se actualicen los valores de los acuerdos comerciales en los tabs con el nuevo acuerdo
            EventBus.$emit('acuerdo-comercial:crear', resp);

            this.$emit('finalizada-exito:creacion', msg); // Emito el evento de exito para mostrar el snackbar
          }
          this.siguientePaso(); // El siguiente paso es finalizar la operación
        })
        .catch((err) => {
          console.log(err);
          this.$emit('finalizada-error:creacion', err.detail);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    /**
     * Prepara las relaciones del acuerdo comercial en caso que sea por defecto / vinculada a uno o más consorcios
     * Elimino relaciones en caso de libre
     * Elimino el tipo producto en caso de ser una vinculada a consorcio, ya que se infiere a través del consorcio (en la relación)
     */
    prepararRelacionesAcuerdo(){
      switch (this.tipo_acuerdo) {
      case acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION:
        this.acuerdo_comercial.api_types_keys_relaciones_request = {
          ['propuesta_comercial']: [
            'administracion'
          ]
        };
        break;
      case acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO:
        if (this.acuerdo_comercial.establecer_propuesta_por_defecto){
          this.acuerdo_comercial.api_types_keys_relaciones_request = {
            ['propuesta_comercial']: [
              'consorcios',
              'administracion' // Para setear por default el acuerdo a la administración
            ]
          };

          // En este modo consigo la admin a asignar desde consorcios pendientes
          if (this.modo_creacion_para_consorcios_pendientes){
            this.acuerdo_comercial.administracion = this.consorcios_pendientes[0].administracion;
          }
        }
        else{
          this.acuerdo_comercial.api_types_keys_relaciones_request = {
            ['propuesta_comercial']: [
              'consorcios'
            ]
          };
        }
        this.acuerdo_comercial.consorcios = this.acuerdo_comercial.consorcios_seleccionados;
        this.acuerdo_comercial.tipo_producto = null; // No hace falta setear el tipo de producto, ya que lo infiere por cada consorcio

        // Seteo las relaciones de la administración y el consorcio seleccionado al acuerdo comercial nuevo
        if(this.consorcio_seleccionado && this.consorcio_seleccionado.administracion) {
          this.acuerdo_comercial.consorcio = this.consorcio_seleccionado; // Seteo la relación del consorcio con el consorcio seleccionado
          this.acuerdo_comercial.administracion = this.consorcio_seleccionado.administracion; // Seteo la relación de la administración con el consorcio seleccionado
        }
        break;
      default: // Libre
        this.acuerdo_comercial.api_types_keys_relaciones_request = null;
        break;
      }
    },

    /**
     * Creo e inicializo/agrego todos los atributos necesarios al AC
     */
    inicializarAcuerdo(){
      this.acuerdo_comercial = new AcuerdoComercial();

      if (this.modo_creacion_para_consorcios_pendientes){

        this.acuerdo_comercial.tipo_propuesta = acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO;
        this.acuerdo_comercial.tipo_producto = this.consorcios_pendientes[0].tipo; // Pueden ser de disintos tipos (barrios/edificios), por lo tanto, tomo el primero como por defecto
        this.acuerdo_comercial.solo_comunicacion = null;

        this.acuerdo_comercial.seleccion_plantilla_personalizada = 1;

        // Si la creación es usando el acuerdo por defecto, la utilizo como modelo para rellenar
        if (this.tipo_creacion_para_consorcios_pendientes === this.USAR_ACUERDO_POR_DEFECTO_ADMIN){
          this.acuerdo_comercial.rellenarConAcuerdo(this.consorcios_pendientes[0].propuesta_default);
        }

        // Relaciones (ya tengo la lista de consorcios y su administración)
        this.acuerdo_comercial.administracion = null; // No hace falta setear la administración porque no se envia.
        this.acuerdo_comercial.distinta_administracion = this.consorcios_pendientes_distinta_administracion;
        this.acuerdo_comercial.consorcios = this.consorcios_pendientes;
        this.acuerdo_comercial.consorcios_seleccionados = this.consorcios_pendientes;
      }
      else{
        switch (this.tipo_acuerdo) {
        case acuerdo_comercial_constantes.TipoAcuerdo.LIBRE: // [acuerdo_libre - no esta en uso actualmente]
          this.acuerdo_comercial.tipo_propuesta = acuerdo_comercial_constantes.TipoAcuerdo.LIBRE;
          this.acuerdo_comercial.solo_comunicacion = false;
          this.acuerdo_comercial.tipo_producto = acuerdo_comercial_constantes.TipoConsorcio.EDIFICIO;

          break;
        case acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION:
          this.acuerdo_comercial.tipo_propuesta = acuerdo_comercial_constantes.TipoAcuerdo.ADMINISTRACION;
          this.acuerdo_comercial.solo_comunicacion = null;
          this.acuerdo_comercial.tipo_producto = null;
          break;
        default: // Masiva y vinculada a un consorcio
          this.acuerdo_comercial.tipo_propuesta = acuerdo_comercial_constantes.TipoAcuerdo.CONSORCIO;
          this.acuerdo_comercial.solo_comunicacion = null;
          this.acuerdo_comercial.tipo_producto = null;
          break;
        }

        this.acuerdo_comercial.seleccion_plantilla_personalizada = 1; // personalizada
        this.acuerdo_comercial.plantilla = null;

        // Relaciones
        this.acuerdo_comercial.administracion = null;
        this.acuerdo_comercial.consorcios = null;
      }
    },
  },
};
</script>

<style lang="scss">
#ca-sidesheet-creacion{

  .v-toolbar__title {
    font-size: 20px;
    font-weight: 400;
    line-height: 100%;
  }

  .boton-atras{
    color: color(naranja);
    background-color: inherit;
  }

  .boton-cancelar {
    color: color(negro);
    background-color: inherit;
    box-shadow: none;
    margin-left:8px;
  }

  .content-sidesheet-creacion{
    // Modifico el estilo del loading para darle opacidad y otro color más claro
    .ca-sidesheet-content-loading{
      background-color: color(blanco);
      opacity: 0.8;
    }
  }

}
</style>